// Keep a live binding for existing synchronous consumers. SDK presence alone is
// not evidence of a mini program: ordinary WeChat pages also load the SDK.
export let IS_MINIPROGRAM = false

export function isMiniProgram() {
  if (window.__wxjs_environment === 'miniprogram' || /\bminiProgram\b/i.test(navigator.userAgent)) {
    IS_MINIPROGRAM = true
  }
  return IS_MINIPROGRAM
}

let pending

// null means the bridge did not confirm the environment in time. Do not cache
// that result, so opening the payment panel again can retry a late SDK/bridge.
export function resolveMiniProgramEnv() {
  if (isMiniProgram()) return Promise.resolve(true)
  if (pending) return pending

  const sdk = window.wx && window.wx.miniProgram
  if (!/MicroMessenger/i.test(navigator.userAgent) && !window.WeixinJSBridge && !sdk) {
    return Promise.resolve(false)
  }

  pending = new Promise(resolve => {
    let settled = false
    let checking = false
    let pollTimer
    let timeoutTimer
    const finish = value => {
      if (settled) return
      settled = true
      clearInterval(pollTimer)
      clearTimeout(timeoutTimer)
      document.removeEventListener('WeixinJSBridgeReady', check)
      if (value === true) IS_MINIPROGRAM = true
      resolve(value)
    }
    const check = () => {
      if (settled) return
      if (isMiniProgram()) return finish(true)
      const miniProgram = window.wx && window.wx.miniProgram
      if (checking || !miniProgram || typeof miniProgram.getEnv !== 'function') return
      checking = true
      try {
        miniProgram.getEnv(result => {
          checking = false
          if (isMiniProgram()) finish(true)
          else if (result && typeof result.miniprogram === 'boolean') finish(result.miniprogram)
        })
      } catch (error) {
        checking = false
      }
    }
    document.addEventListener('WeixinJSBridgeReady', check)
    pollTimer = setInterval(check, 100)
    timeoutTimer = setTimeout(() => finish(isMiniProgram() ? true : null), 1500)
    check()
  }).then(value => {
    pending = undefined
    return value
  })
  return pending
}

isMiniProgram()
